import { EventEmitter } from '@angular/core';
import { ApiService } from "../../app/api.service";
var ComponentsSwiper = (function () {
    function ComponentsSwiper(apiService) {
        this.apiService = apiService;
        this.Close = new EventEmitter();
    }
    ComponentsSwiper.prototype.ngOnInit = function () {
        var _this = this;
        this.apiService.ajax({
            "type": "get",
            "url": '/sr/incentiveLine/getIncentiveLineUserReport'
        }).subscribe(function (result) {
            _this.studyReport = result;
        });
    };
    ComponentsSwiper.prototype.ngAfterViewInit = function () {
        $("#swiperCloser").hide();
        var hammertime = new Hammer(document.getElementById('swipeContainer'));
        hammertime.get('swipe').set({ direction: Hammer.DIRECTION_ALL });
        hammertime.on('swipeup swipedown', this.logEventType);
    };
    ComponentsSwiper.prototype.logEventType = function (ev) {
        var currentLI = $("#swipeContainer .current");
        var currentPre = $("#swipeContainer .pre");
        var currentNext = $("#swipeContainer .next");
        //向上
        if (ev.type == "swipeup") {
            var nextObj = currentLI.next();
            if (nextObj.length == 1) {
                currentPre.removeClass("pre");
                currentNext.removeClass("next");
                currentLI.removeClass("current").addClass("pre");
                nextObj.addClass("current");
                if (nextObj.next().length == 0) {
                    $("#swiperCloser").show();
                    $("#swiperArrow").hide();
                }
            }
        }
        //向下
        if (ev.type == "swipedown") {
            var preObj = currentLI.prev();
            if (preObj.length == 1) {
                currentPre.removeClass("pre");
                currentNext.removeClass("next");
                currentLI.removeClass("current").addClass("next");
                preObj.addClass("current");
                preObj.prev().addClass("pre");
            }
            $("#swiperCloser").hide();
            $("#swiperArrow").show();
        }
    };
    ComponentsSwiper.prototype.CloseSwiper = function () {
        this.Close.emit();
    };
    return ComponentsSwiper;
}());
export { ComponentsSwiper };



// WEBPACK FOOTER //
// ./src/component/swiper/component.swiper.ts.pre-build-optimizer.js